import Profession from './profession';
export default Profession